/*
 * @Author: xuhuan
 * @Date: 2023-07-12 10:03:41
 * @Description: file content
 * @LastEditors: xuhuan
 * @LastEditTime: 2023-07-14 09:46:59
 */
import { createStore } from "vuex";

export default createStore({
  state: {
    // 左侧菜单栏是否展开
    isCollapse: false,
    // 菜单
    menu:[]
  },
  getters: {},
  mutations: {
    CHANGE(state, value) {
      state.isCollapse = value;
    },
    Menu(state,val){
      state.menu=val
    }
  },
  actions: {
    change(conted, val) {
      conted.commit("CHANGE", val);
    },
    menu(conted,val){
      conted.commit('MENU',val)
    }
  },
  modules: {},
});
